module.exports = __webpack_public_path__ + "img/bottomimg.e530b581.png";